import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { Get, Post } from '../../../../utils/httpProvider';
import { LICHHOCTHUCHANH_API, HOPDONGCHITIET_API, ACCOUNT_AUTHINFO_API } from '../../../../utils/apiUrl';

const BoSungHocVienModal = ({ show, onHide, contractId, currentLichId, ngayDiemDanh, onSuccess }) => {
    const [students, setStudents] = useState([]);
    const [loadingStudents, setLoadingStudents] = useState(false);
    const [selectedStudentId, setSelectedStudentId] = useState('');
    const [selectedNgay, setSelectedNgay] = useState('');
    const [lyDoDieuPhoi, setLyDoDieuPhoi] = useState('Giảng viên thống nhất điều phối');
    const [ghiChu, setGhiChu] = useState('');
    
    const [checkingStatus, setCheckingStatus] = useState(false);
    const [checkResult, setCheckResult] = useState(null);
    const [submitting, setSubmitting] = useState(false);

    // Mặc định gán ngày khi mở modal bằng ngày đang xem bên ngoài bảng điểm danh
    useEffect(() => {
        if (show) {
            setSelectedNgay(ngayDiemDanh || '');
        }
    }, [show, ngayDiemDanh]);

    // Fetch toàn bộ học viên của khóa học và giải quyết tên SSO
    useEffect(() => {
        if (show && contractId) {
            fetchContractStudents();
        }
    }, [show, contractId]);

    // Khi đổi ngày hoặc học viên, tự động check lại conflict chéo lịch
    useEffect(() => {
        if (selectedStudentId && selectedNgay) {
            triggerCheckConflict(selectedStudentId, selectedNgay);
        } else {
            setCheckResult(null);
        }
    }, [selectedStudentId, selectedNgay]);

    const fetchContractStudents = async () => {
        setLoadingStudents(true);
        try {
            const res = await Get(`${HOPDONGCHITIET_API.GET_HOCVIENS}/${contractId}`);
            const accountIds = res?.$values || res || [];

            const detailTasks = accountIds.map(async (accountId) => {
                try {
                    const accountInfo = await Get(ACCOUNT_AUTHINFO_API.GET_BY_ID_ACCOUNT, accountId);
                    const profile = accountInfo?.accountAuthInfo || accountInfo?.AccountAuthInfo || accountInfo;
                    const lastName = profile?.lastName || profile?.LastName || "";
                    const middleName = profile?.middleName || profile?.MiddleName || "";
                    const firstName = profile?.firstName || profile?.FirstName || "";
                    const fullName = [lastName, middleName, firstName].map(n => n?.trim()).filter(Boolean).join(" ");
                    return {
                        id: accountId,
                        accountId: accountId,
                        fullName: fullName || "Chưa xác định",
                        pseudonym: profile?.pseudonym || profile?.Pseudonym || ""
                    };
                } catch {
                    return { id: accountId, accountId: accountId, fullName: "Lỗi tải thông tin" };
                }
            });

            const resolvedStudents = await Promise.all(detailTasks);
            setStudents(resolvedStudents);
        } catch (err) {
            toast.error("Không thể lấy danh sách học viên của khóa.");
        } finally {
            setLoadingStudents(false);
        }
    };

    const triggerCheckConflict = async (studentId, dateVal) => {
        setCheckingStatus(true);
        setCheckResult(null);
        try {
            const res = await Get(
                `${LICHHOCTHUCHANH_API.KIEM_TRA_HOC_VIEN_NGOAI_LICH}?lichId=${currentLichId}&hopDongChiTietHocVienId=${studentId}&ngay=${dateVal}`
            );
            setCheckResult(res);
        } catch (err) {
            toast.error("Lỗi kiểm tra thông tin chéo lịch học viên.");
        } finally {
            setCheckingStatus(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedStudentId) {
            toast.error("Vui lòng chọn học viên.");
            return;
        }
        if (!selectedNgay) {
            toast.error("Vui lòng chọn ngày học thực tế.");
            return;
        }

        if (checkResult && !checkResult.coTheBoSung) {
            toast.error(checkResult.canhBaoText || "Học viên bị xung đột lịch không thể bổ sung.");
            return;
        }

        setSubmitting(true);
        try {
            const payload = {
                lichThucTeId: currentLichId,
                hopDongChiTietHocVienId: selectedStudentId,
                ngayThucTe: selectedNgay,
                lyDoDieuPhoi: lyDoDieuPhoi,
                xacNhanChuyenBuoi: checkResult?.requireConfirm || false,
                ghiChu: ghiChu
            };

            const res = await Post(LICHHOCTHUCHANH_API.BO_SUNG_HOC_VIEN_NGOAI_LICH, null, payload);
            if (res?.success || res) {
                toast.success("Bổ sung học viên ngoài lịch thành công.");
                handleReset();
                onSuccess();
                onHide();
            }
        } catch (err) {
            toast.error(err?.response?.data?.message || err?.message || "Đã xảy ra lỗi hệ thống.");
        } finally {
            setSubmitting(false);
        }
    };

    const handleReset = () => {
        setSelectedStudentId('');
        setLyDoDieuPhoi('Giảng viên thống nhất điều phối');
        setGhiChu('');
        setCheckResult(null);
    };

    return (
        <Modal show={show} onHide={() => { handleReset(); onHide(); }} centered>
            <Modal.Header closeButton>
                <Modal.Title className="font-weight-bold text-primary small text-uppercase">
                    <i className="fas fa-user-plus mr-2"></i> Bổ sung học viên ngoài lịch
                </Modal.Title>
            </Modal.Header>
            <Form onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group className="mb-3">
                        <Form.Label className="font-weight-bold small text-muted">Chọn học viên cần bổ sung <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="select"
                            value={selectedStudentId}
                            onChange={(e) => setSelectedStudentId(e.target.value)}
                            disabled={loadingStudents}
                            style={{ borderRadius: '8px' }}
                            required
                        >
                            <option value="">-- Chọn học viên --</option>
                            {students.map(std => (
                                <option key={std.id} value={std.id}>
                                    {std.fullName} {std.pseudonym ? `(${std.pseudonym})` : ''}
                                </option>
                            ))}
                        </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="font-weight-bold small text-muted">Ngày học thực tế bổ sung <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            type="date"
                            value={selectedNgay}
                            onChange={(e) => setSelectedNgay(e.target.value)}
                            style={{ borderRadius: '8px' }}
                            required
                        />
                    </Form.Group>

                    {checkingStatus && (
                        <div className="text-primary small mb-3">
                            <i className="fas fa-spinner fa-spin mr-1"></i> Đang kiểm tra chéo lịch học viên...
                        </div>
                    )}

                    {checkResult && (
                        <div className="mb-3">
                            {checkResult.coTheBoSung ? (
                                checkResult.requireConfirm ? (
                                    <Alert variant="warning" className="small py-2 mb-0">
                                        <i className="fas fa-exclamation-triangle mr-2"></i>
                                        {checkResult.canhBaoText}
                                    </Alert>
                                ) : (
                                    <Alert variant="success" className="small py-2 mb-0">
                                        <i className="fas fa-check-circle mr-2"></i>
                                        {checkResult.canhBaoText || "Học viên đủ điều kiện bổ sung."}
                                    </Alert>
                                )
                            ) : (
                                <Alert variant="danger" className="small py-2 mb-0">
                                    <i className="fas fa-times-circle mr-2"></i>
                                    {checkResult.canhBaoText}
                                </Alert>
                            )}
                        </div>
                    )}

                    <Form.Group className="mb-3">
                        <Form.Label className="font-weight-bold small text-muted">Lý do điều phối thực tế <span className="text-danger">*</span></Form.Label>
                        <Form.Control
                            as="select"
                            value={lyDoDieuPhoi}
                            onChange={(e) => setLyDoDieuPhoi(e.target.value)}
                            style={{ borderRadius: '8px' }}
                        >
                            <option value="Giảng viên thống nhất điều phối">Giảng viên thống nhất điều phối</option>
                            <option value="Học viên xin chuyển buổi">Học viên xin chuyển buổi</option>
                            <option value="Lý do khác">Lý do khác</option>
                        </Form.Control>
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label className="font-weight-bold small text-muted">Ghi chú thêm</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="Nhập ghi chú tùy ý (nếu có)..."
                            value={ghiChu}
                            onChange={(e) => setGhiChu(e.target.value)}
                            style={{ borderRadius: '8px' }}
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="light" style={{ borderRadius: '6px' }} onClick={() => { handleReset(); onHide(); }}>
                        Hủy
                    </Button>
                    <Button
                        variant="primary"
                        type="submit"
                        style={{ borderRadius: '6px', fontWeight: 'bold' }}
                        disabled={submitting || checkingStatus || (checkResult && !checkResult.coTheBoSung)}
                    >
                        {submitting ? 'Đang bổ sung...' : 'Xác nhận bổ sung'}
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default BoSungHocVienModal;
